module.exports = __webpack_public_path__ + "img/ic_dd.6a105ab2.svg";